import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiAlertOctagon, FiRefreshCw, FiTrash2 } = FiIcons;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
    this.handleReload = this.handleReload.bind(this);
    this.handleClearCache = this.handleClearCache.bind(this);
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente renderizado muestre la interfaz de repuesto
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // También puedes enviar el error a un servicio de reporte de errores
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload() {
    window.location.reload();
  }

  handleClearCache() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4 font-mono">
          <div className="max-w-3xl w-full bg-slate-800 rounded-xl shadow-2xl border border-red-500/50 overflow-hidden">
            <div className="bg-red-500/10 p-6 border-b border-red-500/20 flex items-center gap-4">
              <div className="p-3 bg-red-500 rounded-lg">
                <SafeIcon icon={FiAlertOctagon} className="text-white text-2xl" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">Error de Renderizado Detectado</h1>
                <p className="text-red-400 text-sm">La aplicación se detuvo para prevenir daños en los datos.</p>
              </div>
            </div>

            <div className="p-6 space-y-4">
              <div className="bg-slate-950 p-4 rounded border border-slate-700 overflow-auto max-h-40">
                <p className="text-red-400 font-bold mb-2">Mensaje:</p>
                <code className="text-slate-300 text-xs break-all">
                  {this.state.error && this.state.error.toString()}
                </code>
              </div>

              <div className="bg-slate-950 p-4 rounded border border-slate-700 overflow-auto max-h-60">
                <p className="text-blue-400 font-bold mb-2">Stack Trace:</p>
                <pre className="text-slate-400 text-[10px] leading-tight">
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </div>

              <div className="flex flex-wrap gap-3 pt-4">
                <button
                  onClick={this.handleReload}
                  className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  <SafeIcon icon={FiRefreshCw} />
                  Recargar Aplicación
                </button>
                <button
                  onClick={this.handleClearCache}
                  className="flex items-center gap-2 bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  <SafeIcon icon={FiTrash2} />
                  Limpiar Cache y Salir
                </button>
              </div>
            </div>
            
            <div className="bg-slate-900/50 p-4 text-center">
              <p className="text-slate-500 text-xs">
                Por favor, captura una pantalla de este error y envíala al equipo de soporte ITURRI.
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;